let axios = require('axios');
module.exports = {

    record : (action, phone) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        let sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        let serviceParams = { action: action, extension: sessionData.extension, phone:phone};

        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/audioRecording`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: serviceParams
        };
        axios(options).then(response => {
            //console.log('🐞DEBUG executeUserAMIAction responseeeeeeeeeee:', response);
        });
    },


    // getAudioFile:(params) =>{
    //     let promiseAudio = new Promise((resolve, reject) => {
    //         //setTimeout(function () { resolve(10); }, 5000);

    //     });
    //     return promiseAudio;
    // }
   
};

